import { useEffect, useState } from 'react'
import api from "../../../services/api";
import { Box, Text, Button, LoadComponent } from '..'
import { setImovelTab, setBuildingTab, openCompanyTab } from '../../../helpers/cretool-extjs/Tabs'
import { useApp } from '../../../contexts';
import { translateText } from '../../../helpers/util';

const IndustrialCompaniesLogos = ({ type = 'tenants', industrialId }) => {

    const [companies, setCompanies] = useState([])
    const [load, setLoad] = useState(false)
    const { language, translations, userCountry } = useApp();
    useEffect(() => {
        // setLoad(true)
        api.get(`/industrial/${industrialId}/${type}`).then(response=>{
            const { [type]: companies } = response.data;
            setCompanies(companies)
            // setLoad(false)
        });
       
    }, []);

    const handleSeeAll = (e)=>{
        e.preventDefault();
        setBuildingTab({tab: type=='tenants' ? 'tabEmpresasEdificio' : 'tabProprietariosEdificio'})
    }

    const handleClickLogoCompany = (company) => {
        company.id_contato = typeof company.id_ocupante !== "undefined" ? company.id_ocupante : company.id_proprietario
        openCompanyTab(company);
    }

    return (
        <LoadComponent isLoading={load}>
            {/* <Box sx={{ position: 'relative' }}> */}
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                    <Text style={{ fontSize: 12 }}>{type=='tenants' ? translateText("Principais Ocupantes", language, translations, userCountry) : translateText("Proprietários", language, translations, userCountry)}</Text>
                    <Button onClick={handleSeeAll}>{translateText("Ver Todos", language, translations, userCountry)}</Button>
                </Box>
                <Box sx={{ flexDirection: 'row', display: 'flex', alignItems: 'center', marginTop: 1 }}>
                    {companies.map((company, index) => {
                        
                        if(index<5) return (
                            <Box onClick={() => handleClickLogoCompany(company)} sx={{ marginRight: 2, cursor: 'pointer', display: 'flex' }} key={`companyLogo.${company.id_contato}.${type}.${index}`}>
                                {company.url_logotipo && 
                                    <img 
                                        src={`https://d6bmyxfy7viyd.cloudfront.net/${company.url_logotipo}`} 
                                        width={60}
                                        height={60} 
                                        style={{ objectFit: 'contain'}}
                                    /> 
                                }
                                {!company.url_logotipo && <Text style={{fontSize: 10}}>{company.nome_contato}</Text>}
                            </Box>
                        )
                    })}
                </Box>
            {/* </Box > */}
        </LoadComponent>
    )
}

export { IndustrialCompaniesLogos }